import ArticleLayout from '@/components/feature/ArticleLayout';
import { isSugargooLegit } from '@/utils/articleContent';

export default function IsSugargooLegitPage() {
  return <ArticleLayout article={isSugargooLegit} />;
}